module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offer_wrap"
  }, [_c('div', {
    staticClass: "offer_box"
  }, [_c('div', {
    staticClass: "offer_case offer_header"
  }, [_c('div', [_c('img', {
    staticClass: "offer_logo",
    attrs: {
      "src": require("../assets/img/offer/Offer-logo.png")
    }
  })]), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "offer_maintitle"
  }, [_vm._v("Работайте проще - зарабатывайте больше. "), _c('br'), _vm._v(" Первый сервис с элементами МИС* и инструментом для привлечения клиентов.")])]), _vm._v(" "), _c('div', {
    staticClass: "offer_titleaddinfo"
  }, [_vm._v("*МИС - медицинская информационная система"), _c('br'), _vm._v("**для начала работы необходимо минимум одно устройство (компьютер, планшет, ваш личный смартфон) с доступом в интернет")])]), _vm._v(" "), _c('div', {
    staticClass: "offer_case offer_case_t1 offer_newclients"
  }, [_c('div', [_c('h2', {
    staticClass: "offer_h2"
  }, [_vm._v("Подключившись, вы получаете")])]), _vm._v(" "), _c('div', {
    staticClass: "offer_content"
  }, [_c('div', {
    staticClass: "offer_left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/offer/Offer-carddoc.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "offer_right"
  }, [_c('div', [_c('h3', {
    staticClass: "offer_h3"
  }, [_vm._v("Новых клиентов")])]), _vm._v(" "), _c('div', {
    staticClass: "offer_descr"
  }, [_vm._v("Тысячи потенциальных клиентов в вашем городе увидят вас (ваших врачей) в первых рядах списка специалистов с возможностью моментальной записи на прием")])])])]), _vm._v(" "), _c('div', {
    staticClass: "offer_case offer_case_t2 offer_smartagenda"
  }, [_c('div', {
    staticClass: "offer_content"
  }, [_c('div', {
    staticClass: "offer_right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/offer/Offer-agenda.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "offer_left"
  }, [_c('div', [_c('h3', {
    staticClass: "offer_h3"
  }, [_vm._v("Умную электронную регистратуру")])]), _vm._v(" "), _c('div', {
    staticClass: "offer_descr"
  }, [_vm._v("(на ПК, в планшете и телефоне) \n\t                    "), _c('ul', {
    staticClass: "offer_agendalist"
  }, [_c('li', [_vm._v("Гибкая настройка графика каждому сотруднику;")]), _vm._v(" "), _c('li', [_vm._v("Контроль загрузки и эффективности работы;")]), _vm._v(" "), _c('li', [_vm._v("Система уведомлений о новых событиях;")]), _vm._v(" "), _c('li', [_vm._v("Возможность автоматизации (полной или частичной) взаимодействий с клиентами на этапе записи")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "offer_case offer_case_t1 offer_reputation"
  }, [_c('div', {
    staticClass: "offer_content"
  }, [_c('div', {
    staticClass: "offer_left"
  }, [_c('img', {
    staticClass: "offer_stars",
    attrs: {
      "src": require("../assets/img/offer/Offer-reputation.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "offer_right"
  }, [_c('div', [_c('h3', {
    staticClass: "offer_h3"
  }, [_vm._v("Инструменты управления репутацией")])]), _vm._v(" "), _c('div', {
    staticClass: "offer_descr"
  }, [_vm._v("Управляйте своей репутацией. Создайте свою страницу. Получайте отзывы о работе своих сотрудников. Получайте уведомления о полученых отзывах. Давайте официальные ответы на них. Ваши благодарные пациенты всегда смогут вам в этом помочь.*")])]), _vm._v(" "), _c('div', {
    staticClass: "offer_descr fullw"
  }, [_vm._v("*Факт! Неизвестность вызывает дискомфорт: Клиенты предпочитают специалистов с отзывами значительно больше специалистов с неизвестной репутацией")])])]), _vm._v(" "), _c('hr', {
    staticClass: "offer_hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "offer_case offer_case_t1 offer_anotherbonuses"
  }, [_c('div', {
    staticClass: "offer_content"
  }, [_c('div', [_c('h3', {
    staticClass: "offer_h3"
  }, [_vm._v("Личный кабинет каждому сотруднику и клиенту")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "offer_h3"
  }, [_vm._v("Систему управления взаимоотношениями с клиентами")])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "offer_h3"
  }, [_vm._v("Интергацию с вашим существующим сайтом")])]), _vm._v(" "), _c('h2', {
    staticClass: "offer_h2"
  }, [_vm._v("И много другое вместе с развитием проекта")])])]), _vm._v(" "), _c('div', {
    staticClass: "offer_case offer_footer offer_header"
  }, [_c('div', {
    staticClass: "offer_descrwhite"
  }, [_vm._v("Наша цель создать наилучший медицинский сервис, доступный каждому. "), _c('br'), _vm._v(" Каждый врач и клиники для нас прежде всего партнеры, совместно для развития проекта. "), _c('br'), _vm._v(" Присоединяйтесь к команде Скраймед сейчас - развивайся вместе с нами!")])]), _vm._v(" "), _c('div', {
    staticClass: "offer_descr offer_footerbg"
  }, [_vm._v("Информация по телефону:"), _c('br'), _c('b', [_vm._v("+380669343289")]), _c('br'), _vm._v("Заявки принимаются ежедневно с 8:00 до 21:00")]), _vm._v(" "), _c('div', {
    staticClass: "offer_footline"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2ef02ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Offer.vue
// module id = 642
// module chunks = 0